import { render, staticRenderFns } from "./TestMembersCreationRoutes.vue?vue&type=template&id=54255abd"
import script from "./TestMembersCreationRoutes.vue?vue&type=script&lang=js"
export * from "./TestMembersCreationRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports